module.exports = __webpack_public_path__ + "img/model.8f985fef.png";